import {
  DROPDOWN_NEXT_RESULT,
  DROPDOWN_PREVIOUS_RESULT,
  DROPDOWN_SET_CONTACTS,
  DROPDOWN_CLEAR_CONTACTS
} from 'constants/Dropdown';

export function nextResult() {
  return {
    type: DROPDOWN_NEXT_RESULT
  };
}

export function previousResult() {
  return {
    type: DROPDOWN_PREVIOUS_RESULT
  };
}

export function setContacts(contacts) {
  return {
    type: DROPDOWN_SET_CONTACTS,
    payload: contacts
  };
}

export function clearContacts() {
  return {
    type: DROPDOWN_CLEAR_CONTACTS
  };
}

export default {
  nextResult,
  previousResult,
  setContacts,
  clearContacts
};
